const {KitModule, registerModule} = window;

class Post extends KitModule {
  constructor($element) {
    super($element);

    this.setVars();
    this.bindEvents();
  }

  setVars() {
    this.tooltip = null;
  }

  bindEvents() {
    if (this.$anchors) {
      this.$anchors.forEach(($anchor) => {
        $anchor.addEventListener('click', this);
      });
    }
  }

  onclick(e) {
    e.preventDefault();
    const target = e.currentTarget;
    const anchorId = target.getAttribute('data-anchor');
    this.tooltip = target.parentNode.querySelector('.tooltip');

    // copy clean url to clipboard
    const cleanUri = window.location.href.split('#')[0];
    const url = `${cleanUri}#${anchorId}`;
    this.copyToClipboard(url);
  }

  copyToClipboard(text) {
    const dummy = document.createElement('textarea');
    document.body.appendChild(dummy);
    dummy.value = text;
    dummy.select();
    document.execCommand('copy');
    document.body.removeChild(dummy);
    this.handleTooltip();
  }

  handleTooltip() {
    this.tooltip.classList.add('is-visible');

    // hide tooltip after 1sec
    setTimeout(() => {
      this.tooltip.classList.remove('is-visible');
    }, 1000);
  }

  unmount() {}
}

registerModule('Post', Post);
